import { render, staticRenderFns } from "./manageGroups.vue?vue&type=template&id=2e1293e6&scoped=true&"
import script from "./manageGroups.vue?vue&type=script&lang=js&"
export * from "./manageGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1293e6",
  null
  
)

export default component.exports